import React, { useMemo } from 'react';
import { ReactComponent as Icon1 } from 'assets/icons/committee/1.svg';
import { ReactComponent as Icon2 } from 'assets/icons/committee/2.svg';
import { ReactComponent as Icon3 } from 'assets/icons/committee/3.svg';
import { ReactComponent as Icon4 } from 'assets/icons/committee/4.svg';
import { ReactComponent as Icon5 } from 'assets/icons/committee/5.svg';
import { ReactComponent as Icon6 } from 'assets/icons/committee/6.svg';
import { ReactComponent as Icon7 } from 'assets/icons/committee/7.svg';
import { ReactComponent as Icon8 } from 'assets/icons/committee/8.svg';
import { ReactComponent as Icon9 } from 'assets/icons/committee/9.svg';
import { ReactComponent as Icon10 } from 'assets/icons/committee/10.svg';
import { ReactComponent as Icon11 } from 'assets/icons/committee/11.svg';
import { ReactComponent as Icon12 } from 'assets/icons/committee/12.svg';
import { ReactComponent as Icon13 } from 'assets/icons/committee/13.svg';
import { ReactComponent as Icon14 } from 'assets/icons/committee/14.svg';
import { ReactComponent as Icon15 } from 'assets/icons/committee/15.svg';
import { ReactComponent as Icon16 } from 'assets/icons/committee/16.svg';
import styled from 'styled-components/macro';
import MainComponent from 'components/common/MainComponent';
import { font } from 'theme/colors';
import { useHistory } from 'react-router-dom';
import { COMMITTEE } from '../../utils/routes';

export const data = [
  {
    key: 1,
    name: 'აგრარულ საკითხთა კომიტეტი',
    icon: <Icon1 />,
    description:
      'სახელმწიფოს აგრარული პოლიტიკის განსაზღვრა; აგრარულ სფეროში რეფორმების განსახორციელებლად კანონმდებლობის შემუშავება; ევროკავშირის კანონმდებლობასთან საქართველოს კანონმდებლობის მიახლოება.<br /><br />' +
      'კომიტეტის მიზანია, კანონშემოქმედებითი და საზედამხედველო ინსტრუმენტების გამოყენებით, უზრუნველყოს:<br />სოფლის მეურნეობის მდგრადი განვითარება და მისი კონკურენტუნარიანობის ზრდა; მიწის რესურსების რაციონალური გამოყენება;<br />სასოფლო-სამეურნეო პროდუქციის წარმოების ზრდის ხელშეწყობა; სოფლის განვითარება და სოფლად სიღარიბის დაძლევა;<br />სოფლის მეურნეობის განვითარების სტრატეგიის განხორციელება; აგრარულ სფეროში მოქმედი კანონმდებლობის აღსრულება.',
    members: '',
    contact: [
      { email: 'iakhalbedashvili@parliament.ge', phone: '(+99532) 2 281 309' },
    ],
  },
  {
    key: 2,
    name: 'ადამიანის უფლებათა დაცვისა და სამოქალაქო ინტეგრაციის კომიტეტი',
    icon: <Icon2 />,
    description:
      'კომიტეტის უფლებამოსილებას მიეკუთვნება ადამიანის უფლებათა და თავისუფლებათა დაცვის მდგომარეობის შესახებ საქართველოს სახალხო დამცველის მიერ წარმოდგენილი ყოველწლიური ანგარიშის განხილვა და აღნიშნულ ანგარიშში მითითებულ დარღვევის ფაქტებზე შესაბამისი რეაგირება; შეზღუდული შესაძლებლობების მქონე პირთა ძირითადი უფლებებისა და თავისუფლებების რეალიზაციაზე ზედამხედველობა.<br /><br />' +
      'კანონშემოქმედებითი და საზედამხედველო ინსტრუმენტების გამოყენებით, კომიტეტი: მონაწილეობს ქვეყანაში ადამიანის უფლებათა და სამოქალაქო ინტეგრაციის ხელშეწყობის საკითხებზე სახელმწიფო პოლიტიკის შემუშავებასა და საკანონმდებლო ბაზის სრულყოფაში; განსაზღვრავს პოლიტიკას თავისუფლებათა დაცვის მიზნით  და უზრუნველყოფს ადამიანის უფლებათა დარღვევის ფაქტების თავიდან აცილებას; ამზადებს სახალხო დამცველის საქმიანობასთან დაკავშირებით წინადადებებს, მოსაზრებებსა და საკანონმდებლო ინიციატივებს; ახორციელებს საპარლამენტო მონიტორინგს იმ დაწესებულებებზე, რომლებიც საქმიანობენ ადამიანის უფლებათა დაცვის სფეროში; ახორციელებს საპარლამენტო კონტროლს იმ ორგანოებზე, რომელთაც ევალებათ საქართველოს სახალხო დამცველის რეკომენდაციების საფუძველზე პარლამენტის მიერ მიცემული დავალებების შესრულება.',
    members: '',
    contact: [
      { email: 'kgrialashvili@parliament.ge', phone: '(+99532) 2 281 319' },
    ],
  },
  {
    key: 3,
    name: 'განათლებისა და მეცნიერების კომიტეტი',
    icon: <Icon3 />,
    description:
      'კომიტეტის უფლებამოსილებას მიეკუთვნება საგანმანათლებლო და სამეცნიერო პოლიტიკის კოორდინაცია, აღნიშნულ სფეროებში ინსტიტუციური რეფორმების განსაზღვრა და ამ რეფორმების განხორციელებაზე ზედამხედველობა; განათლების ყველა საფეხურის განვითარების ხელშეწყობა.<br /><br />' +
      'კომიტეტის მიზანია, კანონშემოქმედებითი და საზედამხედველო ინსტრუმენტების გამოყენებით, უზრუნველყოს: მეცნიერების, პედაგოგებისა და აკადემიური წრეების წარმომადგენლების საერთაშორისო საგანმანათლებლო სივრცეში ინტეგრაცია; განათლებისა და მეცნიერების სფეროებში სამოქალაქო საზოგადოების შესაძლებლობების განვითარება; განათლებისა და მეცნიერების სფეროებში პოლიტიკისა და რეფორმების განხილვის საკითხებში მედიის ჩართულობის უზრუნველყოფა.',
    members: '',
    contact: [{ email: 'ikuchava@parliament.ge', phone: '(+99532) 2 281 305' }],
  },
  {
    key: 4,
    name: 'გარემოს დაცვისა და ბუნებრივი რესურსების კომიტეტი',
    icon: <Icon4 />,
    description:
      'კომიტეტი განსაზღვრავს სახელმწიფო პოლიტიკას გარემოს დაცვის სფეროში და ახორციელებს მისი აღსრულების კონტროლს.<br /><br />' +
      'კომიტეტის მიზანია, კანონშემოქმედებითი და საზედამხედველო ინსტრუმენტების გამოყენებით, უზრუნველყოს: ქვეყანაში არსებულ ძირითად გარემოსდაცვით და ბუნებრივ რესურსებთან დაკავშირებული საკითხების საკანონმდებლო რეგულირება; ატმოსფერული ჰაერის, ტყისა და ბიომრავალფეროვნების დაცვა; ბუნებრივი რესურსების რაციონალური გამოყენება; ჯანსაღი ურბანული გარემოს შექმნა; ეფექტიანი გარემოსდაცვით ზედამხედველობა; სექტორული რეფორმების ინიცირება და მხარდაჭერა ისეთ სფეროებში, როგორებიცაა: წიაღით სარგებლობა, წყლის რესურსების მართვა, გარემოს დაცვა და სოფლად ინტეგრირება, ქიმიური ნივთიერებების მართვა და ნარჩენების მართვა.',
    members: '',
    contact: [
      { email: 'skurasbediani@parliament.ge', phone: '(+99532) 2 281 316' },
    ],
  },
  {
    key: 5,
    name: 'დარგობრივი ეკონომიკისა და ეკონომიკური პოლიტიკის კომიტეტი',
    icon: <Icon5 />,
    description:
      'კომიტეტი განსაზღვრავს ქვეყნის ეკონომიკური, მათ შორის, დარგობრივი ეკონომიკური პოლიტიკის ძირითად მიმართულებებს.<br /><br />' +
      'კომიტეტის უფლებამოსილება ვრცელდება ისეთ სფეროებზე როგორებიცაა: ენერგეტიკა, კონკურენცია, ელექტრონული კომუნიკაციები, ვაჭრობა, სახელმწიფო შესყიდვები, სივრცითი მოწყობა, პროდუქტის უსაფრთხოება, სატრანსპორტო პოლიტიკა, სახელმწიფო ქონება და ბიზნესის ხელშეწყობა.',
    members: '',
    contact: [
      { email: 'tshabashvili@parliament.ge', phone: '(+99532) 2 281 318' },
    ],
  },
  {
    key: 6,
    name: 'დიასპორისა და კავკასიის საკითხთა კომიტეტი',
    icon: <Icon6 />,
    description:
      'კომიტეტის უფლებამოსილებას მიეკუთვნება ქართული დიასპორისა და კავკასიის ხალხებთან ურთიერთობის განსაზღვრა; უცხოეთში მცხოვრებ თანამემამულეებთან მჭიდრო კავშირების უზრუნველყოფასთან დაკავშირებული კანონპროექტების მომზადება; ქართულ დიასპორასთან მუშაობა საქართველოს ევროატლანტიკურ სივრცეში ინტეგრაციის საკითხებზე.<br /><br />' +
      'კომიტეტის საქმიანობის ძირითადი მიმართულებებია: საქართველოს ფარგლებს გარეთ მოქმედ ქართველოლოგიურ სამეცნიერო ან/და საზოგადოებრივ ცენტრებთან, ორგანიზაციებთან ფართო სპექტრის კავშირების დამყარება; ქართველი და კავკასიელი ხალხების კულტურის პოპულარიზაცია; ერთიანი კავკასიური პოლიტიკის შემუშავება; უცხოეთში მცხოვრები საქართველოს მოქალაქეების სამოქალაქო უფლებების საკითხებზე მუშაობა; კავკასიის რეგიონში უსაფრთხოების, სტაბილურობისა და კეთილდღეობის განმტკიცება.',
    members: '',
    contact: [
      { email: 'lmaghradze@parliament.ge', phone: '(+99532) 2 281 308' },
    ],
  },
  {
    key: 7,
    name: 'ევროპასთან ინტეგრაციის კომიტეტი',
    icon: <Icon7 />,
    description:
      'კომიტეტს განსაკუთრებული როლი აქვს ევროკავშირში ინტეგრაციის პროცესში. კანონშემოქმედებითი და საზედამხედველო ფუნქციების განხორციელების გზით, კომიტეტი ხელს უწყობს საქართველოს ინტეგრაციას ევროკავშირსა და ევროპულ ინსტიტუტებში. იგი ზედამხედველობს ასოცირების შეთანხმებისა და ასოცირების დღის წესრიგის დროულ და ეფექტიან განხორციელებას. ამ მიზნით, კომიტეტი თვალყურს ადევნებს საქართველოს კანონმდებლობის ევროკავშირის სამართალთან დაახლოების პროცესს და მონიტორინგს უწევს ასოცირების შეთანხმებით ნაკისრი ვალდებულებების შესრულებას.',
    members: '',
    contact: [
      { email: 'tkhintibidze@parliament.ge', phone: '(+99532) 2 281 310' },
    ],
  },
  {
    key: 8,
    name: 'თავდაცვისა და უშიშროების კომიტეტი',
    icon: <Icon8 />,
    description:
      'კომიტეტის ძირითად უფლებამოსილებას მიეკუთვნება თავდაცვისა და უსაფრთხოების სექტორთან დაკავშირებული საკანონმდებლო ბაზის დახვეწა და  საქართველოს თავდაცვისა და უსაფრთხოების სექტორში შემავალ უწყებებზე საპარლამენტო კონტროლი. კომიტეტში შექმნილია ნდობის ჯგუფი, რომელიც ზედამხედველობს საქართველოს თავდაცვისა და უსაფრთხოების სფეროში საიდუმლო საქმიანობასა და სპეციალურ პროგრამებს (გარდა იმ ნაწილისა, რომელიც დაკავშირებულია საქმიანობის ფარულ ფორმებსა და მეთოდებთან).',
    members: '',
    contact: [
      { email: 'sbabunashvili@parliament.ge', phone: '(+99532) 2 281 317' },
    ],
  },
  {
    key: 9,
    name: 'იურიდიულ საკითხთა კომიტეტი',
    icon: <Icon9 />,
    description:
      'კანონშემოქმედებითი საქმიანობა;  სახელმწიფო ორგანოების, დაწესებულებებისა და თანამდებობის პირების მიერ საქართველოს პარლამენტისათვის წარდგენილ ანგარიშებთან დაკავშირებით დასკვნების მომზადება; საქართველოს პროკურატურის მიერ გაწეული საქმიანობის შესახებ ანგარიშთან დაკავშირებით პარლამენტის მიერ მიღებული დადგენილების შესრულება; საქართველოს პრემიერ-მინისტრისთვის სამთავრობო პროგრამის მიმდინარეობის შესახებ მიმართვა პროგრამის ცალკეული ნაწილის შესრულების შესახებ ანგარიშის პარლამენტისათვის წარდგენის მოთხოვნით; პარლამენტის მიერ მიღებული ნორმატიული აქტების აღსრულების კონტროლის განხორციელება.',
    members: '',
    contact: [
      { email: 'lkasradze@parliament.ge', phone: '(+99532) 2 281 307' },
    ],
  },
  {
    key: 10,
    name: 'კულტურის კომიტეტი',
    icon: <Icon10 />,
    description:
      'კომიტეტის უფლებამოსილება მოიცავს კულტურის პოლიტიკის, მათ შორის, ამ სფეროში ინსტიტუციური რეფორმებისა და პროგრამების განსაზღვრასა და განხორციელების ზედამხედველობას; კულტურული მემკვიდრეობის დაცვის უზრუნველყოფასთან დაკავშირებული კანონპროექტების მომზადებას; კულტურის ყველა მიმართულების განვითარებას.<br /><br />' +
      'კომიტეტის მიზანია, კანონშემოქმედებითი და საზედამხედველო ინსტრუმენტების გამოყენებით, უზრუნველყოს: კულტურის სფეროში სამეცნიერო კვლევებისა და ინოვაციების ხელშეწყობა; მეცნიერების, პედაგოგების, აკადემიური წრეების და კულტურის სფეროს წარმომადგენლების ინტეგრაცია კულტურის სივრცეში; კულტურის სფეროებში სამოქალაქო საზოგადოების შესაძლებლობების განვითარება.',
    members: '',
    contact: [
      { email: 'ddemetradze@parliament.ge', phone: '(+99532) 2 281 732' },
    ],
  },
  {
    key: 11,
    name: 'რეგიონული პოლიტიკისა და თვითმმართველობის კომიტეტი',
    icon: <Icon11 />,
    description:
      'კომიტეტის უფლებამოსილება მოიცავს კანონშემოქმედებითი და საზედამხედველო ფუნქციების განხორციელებას რეგიონული პოლიტიკისა და ადგილობრივი თვითმმართველობის სფეროში ისეთ მნიშვნელოვან საკითხებზე, როგორებიცაა: საქართველოს რეგიონების და ადგილობრივი თვითმმართველობის განვითარება, დეცენტრალიზაცია და ეფექტური თვითმმართველობა, მთიანი და მაღალმთიანი რეგიონების წინაშე არსებული პრობლემების გადაწყვეტა, საქართველოს სამთავრობო პროგრამით განსაზღვრული გეგმებისა და ამოცანების შესრულების კონტროლი.',
    members: '',
    contact: [
      { email: 'sbezhanidze@parliament.ge', phone: '(+99532) 2 281 314' },
    ],
  },
  {
    key: 12,
    name: 'საგარეო ურთიერთობათა კომიტეტი',
    icon: <Icon12 />,
    description:
      'კომიტეტის უფლებამოსილება მოიცავს ქვეყნის საგარეო პოლიტიკური პრიორიტეტების განსაზღვრის პროცესში ჩართულობას; მოსახლეობის ინფორმირებას ქვეყნის საგარეო ურთიერთობების სფეროში არსებული მდგომარეობისა და სამომავლო გეგმების შესახებ; საერთაშორისო, საზოგადოებრივ, სამთავრობო, საქმიან წრეებთან და ნებისმიერ დაინტერესებულ მხარესთან თანამშრომლობას.<br /><br />' +
      'კომიტეტის საქმიანობის ძირითადი მიმართულებებია: საქართველოს მთავრობის მიერ პარლამენტში წარდგენილი საერთაშორისო ხელშეკრულების რატიფიცირება, დენონსირება და გაუქმება;  საერთაშორისო ხელშეკრულებებიდან გამომდინარე საკანონმდებლო აქტებში ცვლილებების შეტანის განხილვა; საერთაშორისო ურთიერთობების და დიპლომატიური სამსახურის სისტემაში გასატარებელ ღონისძიებათა მოსალოდნელი შედეგების შეფასება და შესაბამისი დასკვნების, რეკომენდაციებისა და გადაწყვეტილებების მომზადება; სხვა სახელმწიფოების პარლამენტებთან რეგულარული ურთიერთობის დასამყარებლად პარლამენტში შექმნილი მეგობრობის ჯგუფების კოორდინაცია და გაწეული საქმიანობის ანგარიშის ყოველწლიურად პარლამენტის ბიუროსათვის წარდგენა; საკანონმდებლო და საზედამხედველო საქმიანობის განხორციელება და საპარლამენტო კავშირების გაძლიერებისა და ქვეყნის საგარეო პოლიტიკური ამოცანების მიღწევის მიზნით საპარლამენტო დიპლომატიის აქტიური გამოყენება.',
    members: '',
    contact: [
      { email: 'nkhatiashvili@parliament.ge', phone: '(+99532) 2 281 311' },
    ],
  },
  {
    key: 13,
    name: 'საპროცედურო საკითხთა და წესების კომიტეტი',
    icon: <Icon13 />,
    description:
      'საპარლამენტო პროცედურების პარლამენტის რეგლამენტით განსაზღვრულ მოთხოვნებთან შესაბამისობა და მათზე სათანადოდ რეაგირება; კანონპროექტის განხილვისათვის დადგენილი პროცედურების დარღვევის ფაქტებზე რეაგირება; პარლამენტის წევრების მიერ საქართველოს პარლამენტის რეგლამენტის მოთხოვნათა შესრულების კონტროლი და შესაბამის დარღვევებზე რეაგირება; პარლამენტის წევრის სტატუსთან პარლამენტის წევრის თანამდებობრივი და სამეწარმეო საქმიანობის შესაბამისობის კონტროლი; კომიტეტებში, დროებით და საგამოძიებო კომისიებში პარლამენტის წევრთა რაოდენობისა და პროპორციული წარმომადგენლობის კვოტების განსაზღვრა.',
    members: '',
    contact: [
      { email: 'mdokhnadze@parliament.ge', phone: '(+99532) 2 281 304' },
    ],
  },
  {
    key: 14,
    name: 'საფინანსო-საბიუჯეტო კომიტეტი',
    icon: <Icon14 />,
    description:
      'კომიტეტის უფლებამოსილება მოიცავს საფინანსო სექტორში არსებული პრობლემების შესწავლასა და პარლამენტის გადაწყვეტილებათა შესრულებისთვის ხელის შეწყობას; სახელმწიფო ბიუჯეტის შესრულებაზე კონტროლს.<br /><br />' +
      'კომიტეტი, კანონშემოქმედებითი და საზედამხედველო ინსტრუმენტების გამოყენებით: ხელმძღვანელობს სახელმწიფო ბიუჯეტის მიღებისა და მასში ცვლილებების შეტანის პროცესს; აფასებს საფინანსო-საბიუჯეტო, ფულად-საკრედიტო, საგადასახადო-საბაჟო და სავალუტო სისტემაში გასატარებელი ღონისძიებების მოსალოდნელი შედეგებს და ამზადებს შესაბამისი დასკვნებს, ცნობებს, რეკომენდაციებსა და გადაწყვეტილებებს; ქმნის სახელმწიფო აუდიტის სამსახურის ანგარიშების განმხილველი მუდმივმოქმედ აუდიტის ჯგუფს.',
    members: '',
    contact: [{ email: 'ilomia@parliament.ge', phone: '(+99532) 2 281 315' }],
  },
  {
    key: 15,
    name: 'სპორტისა და ახალგაზრდულ საქმეთა კომიტეტი',
    icon: <Icon15 />,
    description:
      'სპორტისა და ახალგაზრდული პოლიტიკის ძირითადი მიმართულებებისა და საკანონმდებლო ბაზის შემუშავება და განვითარება; სპორტისა და ახალგაზრდულ საქმეთა სფეროში ეროვნულ კანონმდებლობაში არსებული ხარვეზების გამოვლენა და საუკეთესო საერთაშორისო გამოცდილების დანერგვა.<br /><br />' +
      'კომიტეტის მიზანია, კანონშემოქმედებითი და საზედამხედველო ინსტრუმენტების გამოყენებით უზრუნველყოს: სპორტის  ხელმისაწვდომობა  და  მოსახლეობის  ფიზიკური  აქტივობის  ზრდა; მასობრივი სპორტის განვითარების ხელშეწყობა; მაღალი მიღწევების სპორტის განვითარების ხელშეწყობა; ქვეყნის  საზოგადოებრივ და  ეკონომიკურ  ცხოვრებაში  ახალგაზრდების  აქტიური მონაწილეობის წახალისება; ახალგაზრდების განათლებისა და დასაქმების ხელშეწყობა; სპორტში კარგი მმართველობის და გენდერული თანასწორობის პრინციპების გატარება; ახალგაზრდებისთვის განვითარების თანაბარი შესაძლებლობების შექმნა.',
    members: '',
    contact: [
      { email: 'emachaidze@parliament.ge', phone: '(+99532) 2 281 306' },
    ],
  },
  {
    key: 16,
    name: 'ჯანმრთელობის დაცვისა და სოციალურ საკითხთა კომიტეტი',
    icon: <Icon16 />,
    description:
      'კომიტეტის ძირითად უფლებამოსილებას მიეკუთვნება ჯანმრთელობის, სოციალური დაცვისა და შრომისა და დასაქმების პოლიტიკის ძირითადი მიმართულებების განსაზღვრა; მოსახლეობის ჯანმრთელობის, სოციალური დაცვის, შრომითი, დასაქმების, დედათა და ბავშვთა დაცვის, ოჯახის განვითარების, ხანდაზმულთა, დევნილთა, ვეტერანთა და შეზღუდული შესაძლებლობების მქონე პირთა საკითხების გადაწყვეტის ხელშეწყობა.<br /><br />' +
      'კომიტეტი, კანონშემოქმედებითი და საზედამხედველო ინსტრუმენტების გამოყენებით, უზრუნველყოფს: მოსახლეობის ჯანმრთელობისა და სოციალური დაცვის სფეროში სახელმწიფო პოლიტიკის გატარებას; საყოველთაო ჯანდაცვის პროგრამის განხორციელების კონტროლს; ჯანმრთელობის დაცვისა და სოციალური დახმარების პროგრამების შემუშავებაში, განხილვასა და დამტკიცებაში აქტიურ მონაწილეობას.',
    members: '',
    contact: [{ email: 'ikhasaia@parliament.ge', phone: '(+99532) 2 281 320' }],
  },
];

const $Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-left: 50px;
  padding-right: 30px;
  margin-left: auto;
  margin-right: auto;
`;

const $List = styled.div`
  margin-top: 90px;
  max-height: calc(100vh - 130px - 90px);
  min-height: 500px;
  width: 100%;
  overflow: auto;
  padding-right: 36px;
  padding-top: 20px;
  &::-webkit-scrollbar {
    width: 23px;
    height: 23px;
    background: rgba(196, 196, 196, 0.37);
    border-radius: 100px;
  }
  &::-webkit-scrollbar-thumb {
    background: #1d6ebb;
    border-radius: 100px;
  }
`;

const $Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 60px;
`;

const $Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 400px;
  height: 239px;
  background: linear-gradient(248.85deg, #1d6ebb -12.97%, #125798 102.24%);
  box-shadow: 0 4px 0 0 rgba(30, 80, 128, 1);
  border-radius: 18px;
  cursor: pointer;
  overflow: hidden;
  & .title {
    max-width: 350px;
    font-size: 12px;
    line-height: 15px;
    color: #ffffff;
    margin-top: 24px;
    font-family: ${font.primary};
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 34px;
  }
`;

const Committee = () => {
  const history = useHistory();
  const list: any = useMemo(() => {
    const result: any = [];
    let count = 1;
    let subArr: any = [];
    data.forEach((r: any) => {
      subArr.push(r);
      if (count % 4 === 0) {
        result.push([...subArr]);
        subArr = [];
      }
      count++;
    });
    if (subArr.length > 0) {
      result.push([...subArr]);
    }
    return result;
  }, []);

  return (
    <MainComponent title="კომიტეტები" backStyle={{ top: 148 }}>
      <$Wrapper>
        <$List>
          {list.map((arr: any, i: number) => (
            <$Row key={`row-committee-${i}`}>
              {arr.map((r: any) => (
                <$Box
                  key={r.key}
                  onClick={() => history.push(COMMITTEE + '/' + r.key)}
                >
                  <div className="icon">{r.icon}</div>
                  <div className="title">{r.name}</div>
                </$Box>
              ))}
            </$Row>
          ))}
        </$List>
      </$Wrapper>
    </MainComponent>
  );
};

export default Committee;
